import React from 'react';
import InvoiceList from './InvoiceList';

const InvoicesPage: React.FC = () => <InvoiceList />;

export default InvoicesPage;
